import type { ComponentType } from "react";

/** Places in the top bar that a feature fills (the context selector and environment switch, 1e). */
export type TopBarSlot = "context" | "environment";

const slots = new Map<TopBarSlot, ComponentType>();

/** Puts a component in a top bar slot; throws if the slot is taken. */
export function registerTopBarSlot(slot: TopBarSlot, component: ComponentType): void {
  if (slots.has(slot)) throw new Error(`the top bar slot "${slot}" is already filled`);
  slots.set(slot, component);
}

export const topBarSlot = (slot: TopBarSlot): ComponentType | undefined => slots.get(slot);
